// Predefined color palette for clients (25 distinct colors)
export const CLIENT_COLOR_PALETTE = [
  '#E91E63',  // Pink
  '#9C27B0',  // Purple
  '#673AB7',  // Deep Purple
  '#3F51B5',  // Indigo
  '#2196F3',  // Blue
  '#03A9F4',  // Light Blue
  '#00BCD4',  // Cyan
  '#009688',  // Teal
  '#4CAF50',  // Green
  '#8BC34A',  // Light Green
  '#CDDC39',  // Lime
  '#FFC107',  // Amber
  '#FF9800',  // Orange
  '#FF5722',  // Deep Orange
  '#795548',  // Brown
  '#607D8B',  // Blue Grey
  '#F44336',  // Red
  '#E040FB',  // Purple Accent
  '#448AFF',  // Blue Accent
  '#00E676',  // Green Accent
  '#FF6D00',  // Orange Accent
  '#6D4C41',  // Brown Dark
  '#00838F',  // Cyan Dark
  '#1565C0',  // Blue Dark
  '#7B1FA2',  // Purple Dark
];

// Get a lighter version of a hex color for backgrounds
export const getLighterColor = (hexColor, opacity = 0.15) => {
  if (!hexColor) return 'rgba(156, 163, 175, 0.15)'; // Default gray
  return `${hexColor}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
};

// Get contrasting text color (black or white) based on background
export const getContrastColor = (hexColor) => {
  if (!hexColor) return '#374151'; // Default dark gray
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#1F2937' : '#FFFFFF';
};

// Get a default color based on index
export const getColorByIndex = (index) => {
  return CLIENT_COLOR_PALETTE[index % CLIENT_COLOR_PALETTE.length];
};

// Client Color Badge Component
export const ClientColorBadge = ({ color, name, size = 'md', showName = true, className = '' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span 
        className={`${sizeClasses[size]} rounded-full flex-shrink-0`}
        style={{ backgroundColor: color || '#9CA3AF' }}
      />
      {showName && name && (
        <span className={`${textSizeClasses[size]} text-neutral-700 truncate`}>{name}</span>
      )}
    </span>
  );
};

// Client Color Tag Component (with background)
export const ClientColorTag = ({ color, name, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base'
  };

  return (
    <span 
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClasses[size]} ${className}`}
      style={{ 
        backgroundColor: getLighterColor(color, 0.2),
        color: color || '#4B5563',
        borderLeft: `3px solid ${color || '#9CA3AF'}`
      }}
    >
      {name}
    </span>
  );
};

export default CLIENT_COLOR_PALETTE;
